import React from 'react'
import { Select, Tag } from 'antd'
import styled from 'styled-components'

export const StyledSelect = styled(Select)`
  .ant-select-selection-overflow-item::after {
    content: ',';
    font-weight: 600;
  }

  // ant design v5
  /* .ant-select-selection-overflow-item:nth-last-of-type(-n + 2)::after {
    content: '';
  } */

  .ant-select-selection-overflow-item:last-child:after {
    content: '';
  }

  .ant-select-selection-overflow-item:nth-last-child(3):after {
    content: '';
  }

  .ant-select-selection-overflow-item.ant-select-selection-overflow-item-rest::after {
    content: '';
  }

  .ant-select-selector .ant-select-selection-overflow {
    padding-top: 0px !important;
  }
`

const tagRender = (props) => {
  const { label, value, disabled } = props
  const onPreventMouseDown = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }
  return (
    <Tag
      color={value}
      onMouseDown={onPreventMouseDown}
      closable={false}
      style={{
        marginInlineEnd: 0,
        paddingInlineEnd: 0,
        background: 'transparent',
        color: disabled ? '#BEC7D9' : 'rgba(0, 0, 0, 0.88)',
        fontSize: 14
      }}
    >
      {label}
    </Tag>
  )
}

export default function MultipleSelect(props) {
  const {
    options,
    placeholder,
    disabled,
    value,
    extraAttr,
    onChange,
    onSelectChange
  } = props

  return (
    <StyledSelect
      onChange={triggerChange}
      value={value || undefined}
      tagRender={(props) => {
        return tagRender({ ...props, disabled: disabled })
      }}
      maxTagCount={'responsive'}
      mode="multiple"
      placeholder={placeholder}
      disabled={disabled}
      options={options.map((option) => {
        return {
          value: option.value,
          label: option.label,
          disabled: option.disabled
        }
      })}
      style={{
        height: 45
      }}
      {...extraAttr}
    />
  )

  function triggerChange(value) {
    if (onChange) {
      onChange(value)
    }
    if (onSelectChange) {
      onSelectChange(value)
    }
  }
}
